import { BrowserRouter, Switch, Route, Redirect, Link } from "react-router-dom";
import React from "react"
import TopHeader from "../../AppViews/TopHeader"
import Footer from "../../AppViews/Footer"
import StartupAwardsBanner from "../../../components/StartupAwardsBanner";

import POS from "../../AppViews/POS"
import Payment from "../../AppViews/POS/Payment"
import Invoice from "../../AppViews/POS/components/Invoice"


export default () => {
    return <BrowserRouter>
        <div id="wrapper">
            <nav className="navbar-default navbar-static-side" role="navigation">
                <div className="sidebar-collapse">
                    <ul className="nav metismenu" id="side-menu">
                        <li className="nav-header">
                            <div className="logo-element">
                                IN+
                            </div>
                        </li>
                        <li>
                            <Link to="">
                                <i class={`fas fa-cash-register`} />
                                <span class="nav-label">
                                    Ponto de Vendas
                                </span>
                            </Link>
                        </li>

                    </ul>
                </div>
            </nav >
            <div id="page-wrapper" className="gray-bg">
                <StartupAwardsBanner />
                <TopHeader />
                <Switch>
                    <Route exact={true} path="/" component={POS} />
                    <Route exact={true} path="/pos/payment" component={Payment} />
                    <Route exact={true} path="/sale/:id" component={Invoice} />
                    <Route path="*" component={POS} />
                    <Redirect from="*" to="/" component={POS} />
                </Switch>
                <div className="mb-5"></div>
                <Footer />
            </div>
        </div>
    </BrowserRouter>
}


// WEBPACK FOOTER //
// ./src/views/Seller/Views/index.jsx